import { LegalClientEntity, LegalClientHeadEntity } from 'api/types/entity';
import { parseFullName } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

export const useHeadPageTitle = (
  legalClient: LegalClientEntity | null,
  legalClientHead: LegalClientHeadEntity | null
) => {
  const { t } = useTranslation();

  let fullName = legalClientHead
    ? t('client.legal.legalClientHead.title', {
        name: parseFullName(legalClientHead),
      })
    : '';

  fullName += fullName && legalClient ? ` - ${legalClient.fullName}` : '';

  usePageTitle(fullName);
};
